import { render } from "./WarehouseModule.vue?vue&type=template&id=4d6ad674&scoped=true"
import script from "./WarehouseModule.vue?vue&type=script&lang=js"
export * from "./WarehouseModule.vue?vue&type=script&lang=js"

import "./WarehouseModule.vue?vue&type=style&index=0&id=4d6ad674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6ad674"]])

export default __exports__